import { render, staticRenderFns } from "./EditBusinessImageAndTitlesView.vue?vue&type=template&id=6b44e59a&scoped=true&"
import script from "./EditBusinessImageAndTitlesView.vue?vue&type=script&lang=ts&"
export * from "./EditBusinessImageAndTitlesView.vue?vue&type=script&lang=ts&"
import style0 from "./EditBusinessImageAndTitlesView.vue?vue&type=style&index=0&id=6b44e59a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b44e59a",
  null
  
)

export default component.exports